import { fetchApi } from "./utils";

export const currentAccount = async () => {
  let account = {};
  // try {
  //   account = JSON.parse(localStorage.getItem("account"));
  // } catch (e) {
  //   console.error(e);
  //   localStorage.removeItem("account");
  // }
  // if (!account) {
  try {
    const accounts = await getMyAccounts();
    account = accounts.Accounts[0];
    localStorage.setItem("account", JSON.stringify(account));
  } catch (e) {
    /* ignore if there is no user */
    console.debug(e);
  }
  // }
  return account;
};

/**
 * Get accounts by a user
 */

export const getMyAccounts = async () =>
  fetchApi("/accounts-for-user/me", { method: "GET" });
export const addNewAccount = async (account) =>
  fetchApi("/accounts-for-user/me", {
    addAccountId: true,
    method: "PUT",
    params: { account },
  });
export const updateAccountName = async (accountID, accountName) =>
  fetchApi("/account", { method: "PUT", params: { accountID, accountName } });
